import type { ComponentProps } from 'react'

import { cn } from '@gto/ui/cn'

import { tableStyles } from './table.styles'

export const Container = ({ className, ...props }: ComponentProps<'div'>) => (
  <div
    className={cn(tableStyles().container(), className)}
    // Stable hook for callers that need to measure against the scroll box —
    // it replaces the `[class*="MuiTableContainer"]` those used to match.
    data-ui="table-container"
    {...props}
  />
)
